import { useQuery } from "@tanstack/react-query";
import { getBanner } from "../sevices/bannerApi";

export function useBanner() {
  const { isLoading, data, error, isError, refetch } = useQuery({
    queryKey: ["banner"],
    queryFn: () => getBanner(),
  });

  const filename = data?.data?.data?.filename;

  return { isLoading, error, filename, isError, refetch };
}
